<template>
  <div class="container d-flex flex-column justify-content-center align-items-center vh-100">
    <h1 id="logo">InfoNav</h1>
    <div class="button-container row">
      <div class="col-md-1 mb-1">
      </div>
      <div class="col-md-2 mb-2">
        <a href="/accidents">
          <button class="btn btn-primary btn-lg btn-custom w-100">Incidenti</button>
        </a>
      </div>
      <div class="col-md-2 mb-2">
        <a href="/crimes">
          <button class="btn btn-primary btn-lg btn-custom w-100">Crimini</button>
        </a>
      </div>
      <div class="col-md-2 mb-2">
        <a href="/social_and_commercial_vitality">
          <button class="btn btn-primary btn-lg btn-custom w-100">Vitalità sociale e commerciale</button>
        </a>
      </div>
      <div class="col-md-2 mb-2">
        <a href="/urban_greenery_and_air_quality">
          <button class="btn btn-primary btn-lg btn-custom w-100">Verde urbano e qualità dell'aria</button>
        </a>
      </div>
      <div class="col-md-2 mb-2">
        <a href="/human_perception">
          <button class="btn btn-primary btn-lg btn-custom w-100">Human perception</button>
        </a>
      </div>
      <div class="col-md-1 mb-1">
      </div>
      <!-- Second row with one large button -->
      <div class="col-1">
      </div>
      <div class="col-10">
        <a href="/cyber_social_security">
          <button class="btn btn-info btn-lg btn-custom w-100">CYBER SOCIAL SECURITY</button>
        </a>
      </div>
      <div class="col-1">
      </div>
    </div>
  </div>
</template>

<script>
import {useHead} from '@vueuse/head';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Homepage',
  setup() {
    useHead({
      title: 'InfoNav'
    });
  }
}
</script>

<style scoped>
#logo {
    color: #4078be !important;
    font-weight: bold;
    margin-bottom: 20px;
    font-family: "Poppins", sans-serif !important;
}

.button-container {
    max-width: 1300px;
    margin: 0 auto;
}

.btn-custom {
    border-radius: 10px;
    height: 100%;
}
</style>
